import Ajax from "Utils/ajax";
export const getAllMenus = (data) => Ajax.post('admin/getAllMenus',data);
export const getAllRoleByMenuId = (data) => Ajax.post('admin/getAllRoleByMenuId',data);
export const addUpdateMenuRoles = (data) => Ajax.post('admin/addUpdateMenuRoles',data);
export const getAllocatedRoleByMenuId = (data) => Ajax.post('admin/getAllocatedRoleByMenuId',data);